import { a as e } from "./index828.mjs";
import { a as s } from "./index840.mjs";
import { i } from "./index815.mjs";
import { w as c } from "./index760.mjs";
var a = e, l = s, m = i, u = c, f = u("species"), C = function(n, t) {
  var r = a(n).constructor, o;
  return r === void 0 || m(o = a(r)[f]) ? t : l(o);
};
export {
  C as s
};
